import React, { useEffect, useState } from 'react'
import { ICustomerDetail } from '../../../../common/interfaces'
import { apiUrl } from '../../../../config/api'
import { EditFinalBeneficiaryForm } from '../EditFinalBeneficiaryForm'
import { FinalBeneficiaryCard } from '../FinalBeneficiaryCard'
import { RiskProfileDocumentTable } from '../tables/RiskProfileDocumentTable'

interface IProps {
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  customerDetail: ICustomerDetail | undefined
}

export const ProfileTab: React.FC<IProps> = ({
  customerDetail,
  isError,
  isFetching,
  isLoading,
}) => {
  const [finalBeneficiary, setFinalBeneficiary] = useState<any>(null)

  // 👇 Función para llamar al endpoint
  const getFinalBeneficiary = async (customerId: string) => {
    try {
      const response = await apiUrl.get(`/user/final-beneficiary/${customerId}`)
      setFinalBeneficiary(response.data)
    } catch (error: any) {
      console.error('❌ Error al obtener final beneficiary:', error.response?.data || error.message)
    }
  }

  // 👇 Llamada al cargar el componente
  useEffect(() => {
    if (customerDetail?.id) {
      getFinalBeneficiary(customerDetail.id.toString())
    }
  }, [customerDetail?.id])
  return (
    <>
      <div className='d-flex justify-content-between gap-5'>
        {finalBeneficiary && (
          <div className='col-lg-4 col-md-12 mb-5'>
            <FinalBeneficiaryCard finalBeneficiary={finalBeneficiary} />
          </div>
        )}

        <div className={`card p-4 mb-5 ${finalBeneficiary ? 'col-lg-8' : 'col-12'}`}>
          <div className='d-flex justify-content-between'>
            <h6 className='text-muted fs-4' style={{ color: 'rgb(52, 64, 84)' }}>
              Documentos
            </h6>
          </div>
          <div className='table-responsive mt-5'>
            {(isLoading || isFetching) && !isError ? (
              <div className='text-center m-20 p-20'>
                <div className='spinner-border' role='status'></div>
              </div>
            ) : (
              <RiskProfileDocumentTable customerDetail={customerDetail!} />
            )}
          </div>
        </div>
      </div>
      <div
        className='modal fade p-5 rounded-4'
        tabIndex={-1}
        id='EditFinalBeneficiaryModal'
        role='dialog'
      >
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header py-5 mt-2 fw-bolder'>
              <h1 className='text-alert'>Editar Beneficiario Final</h1>
              <button
                type='button'
                className='close border-0'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='bi bi-x fs-2'></i>
              </button>
            </div>
            <div className='modal-body'>
              <EditFinalBeneficiaryForm
                data={finalBeneficiary}
                onSuccess={() => getFinalBeneficiary(customerDetail!.id.toString())}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
